import React, { createContext, useContext, useState, useEffect } from "react";
import translations from "@/lib/translations";

const LangContext = createContext(null);

export const useLang = () => useContext(LangContext);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("esg_lang") || "en");

  useEffect(() => {
    localStorage.setItem("esg_lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.en?.[key] || key;
  const isRtl = lang === "ar";
  const toggleLang = () => setLang(l => l === "en" ? "ar" : "en");

  return (
    <LangContext.Provider value={{ lang, setLang, t, isRtl, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
};
